import { toast } from "bulma-toast";
import * as yaml from 'js-yaml';
import * as React from 'react';
import * as CopyToClipboard from "react-copy-to-clipboard";
// import { Droparea } from './Droparea/index';
import Dropzone from 'react-dropzone';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { deleteConfirmation, tooltips } from 'src/constants/profileSettings';
import { saveNewGenerator, validateWithoutID } from 'src/utils/api';
import { importCsv } from "src/utils/importCsv";
import { exportGeneratorToJson } from 'src/utils/imUndExport';
import { shortenTo } from 'src/utils/stringManipulation';
import GeneratorEntity from '../../../models/Generator';
import Profile from '../../../models/Profile';
import { loadGenDetails, runGeneratorWithId } from '../../../utils/api';
import { history } from './../../../store/store';
import { IRunResult } from './../EditGenerator/EditGeneratorComponent';
import { GeneratorView } from './GeneratorView';
import TokenManager from './TokenManager';
import TopNav from './TopNav';
import translations from './translations';




// Upload CSS
interface IProps extends InjectedIntlProps {
  filterQuery: string
  generatorList: GeneratorEntity[]
  loadGenerators: any
  loadProfile: any
  profile: Profile
  switchGenView: any
  title: string

  delete: (generator: GeneratorEntity) => void
  dispatchFilterEvent: (query: string) => void
  validator: (generator: GeneratorEntity) => void
  refreshGens: () => void
}


interface IState {
  clipboardText: string
  doneSaving: number
  generatorToDelete: any
  showDeleteDialog: boolean
  showRunView: boolean
  tokenManager: {
    showTokenModal: boolean,
    generator: GeneratorEntity
  }
  generatorToRun: GeneratorEntity
  lastGeneratorToRun: GeneratorEntity
  generatorResult: string
  showUpload: boolean
  isSaving: boolean
  startedSaving: number
  fileCount: number
}

class GeneratorComponent extends React.Component<IProps, IState> {
  private tooltipBottomClass: string = "tooltip is-tooltip-bottom";
  private tooltipLeftClass: string = "tooltip is-tooltip-left";

  constructor(props: IProps) {
    super(props);
    this.state = {
      clipboardText: '',
      doneSaving: 0,
      fileCount: 0,
      generatorResult: "",
      generatorToDelete: null,
      generatorToRun: new GeneratorEntity,
      isSaving: false,
      lastGeneratorToRun: new GeneratorEntity,
      showDeleteDialog: false,
      showRunView: false,
      showUpload: false,
      startedSaving: 0,
      tokenManager: {
        generator: new GeneratorEntity,
        showTokenModal: false,
      }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }


  public componentDidMount() {
    if (!window.location.href.includes("/generators")) {
      history.push("/generators")
    }
  }

  public handleKeyDown(e: React.KeyboardEvent<any>): void {
    const charCode = String.fromCharCode(e.which).toLowerCase()
    if (e.ctrlKey && charCode === 'c') {
      // TODO: Handle Search Shortcut when there is Time
    }
  }

  public openRunView = (generator: GeneratorEntity) => {
    if (this.state.showRunView === true && this.state.generatorToRun === generator) {
      this.run();
    } else {
      // this.setState({
      //   ...this.state,
      //   generatorToRun: generator,
      //   lastGeneratorToRun: this.state.generatorToRun,
      //   showRunView: true,
      // });
      this.run(generator);
      this.setState({
        ...this.state,
        generatorToRun: generator,
        lastGeneratorToRun: this.state.generatorToRun,
        showRunView: true,
      });
    }
  }

  public closeRunView = () => {
    if (this.state.showRunView === true) {
      this.setState({
        ...this.state,
        showRunView: false
      })
    }
  }

  public clickRun(e: React.MouseEvent<HTMLButtonElement>) {
    this.run();
  }

  public run = (generator?: GeneratorEntity) => {
    let genToRun: GeneratorEntity
    if (generator === undefined) {
      genToRun = this.state.generatorToRun
    } else {
      genToRun = generator
    }
    const result = runGeneratorWithId(genToRun.id || '')

    if (this.state.lastGeneratorToRun !== new GeneratorEntity && this.state.lastGeneratorToRun !== this.state.generatorToRun) {
      this.setState({
        ...this.state,
        generatorResult: "<hr>" + this.state.generatorResult
      })
    }

    if (result !== undefined) {
      result.then((data: IRunResult) => {
        if (data) {
          let output = data.htmlContent
          if (data.htmlContent.startsWith("<table>")) {
            output = data.htmlContent.replace("<table>", `<table class='table'>`)
          } else {
            output = '<div class="box">' + data.htmlContent + '</div>'
          }
          this.setState({
            ...this.state,
            clipboardText: data.textContent + '\n' + this.state.clipboardText,
            generatorResult: output + this.state.generatorResult,
            lastGeneratorToRun: this.state.generatorToRun,
          })

        }
      })
    }
  }

  public clearRunResults = () => {
    this.setState({
      ...this.state,
      clipboardText: "",
      generatorResult: ""
    })
  }

  public async confirmDelete(generator: GeneratorEntity) {
    if (this.props.profile.deleteConfirmation === deleteConfirmation.false) {
      await this.setState({
        ...this.state,
        generatorToDelete: generator,
      })
      this.confirmedDeletion();
    } else {
      this.setState({
        ...this.state,
        generatorToDelete: generator,
        showDeleteDialog: true,
      })
    }
  }

  public confirmedDeletion() {
    this.props.delete(this.state.generatorToDelete);
    this.setState({
      ...this.state,
      generatorToDelete: new GeneratorEntity(),
      showDeleteDialog: false,
    })
  }


  public closeModal() {
    this.setState({
      ...this.state,
      generatorToDelete: null,
      showDeleteDialog: false,
    })
  }

  public handleDownloadClicked(gen: GeneratorEntity) {
    loadGenDetails(gen.id || '', (generator: GeneratorEntity) => {
      delete generator.id
      delete generator.hasAllData
      exportGeneratorToJson(generator)
    })
  }

  public showTokenModalForGenerator(gen: GeneratorEntity) {
    this.setState({
      ...this.state,
      tokenManager: {
        generator: gen,
        showTokenModal: true,
      }
    })
  }

  public hideTokenModal() {
    this.setState({
      ...this.state,
      tokenManager: {
        generator: new GeneratorEntity,
        showTokenModal: false
      }
    })
  }

  public render() {
    this.confirmDelete = this.confirmDelete.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.confirmedDeletion = this.confirmedDeletion.bind(this);
    this.showTokenModalForGenerator = this.showTokenModalForGenerator.bind(this);
    this.hideTokenModal = this.hideTokenModal.bind(this);

    // The filter function for the search input on the Generator Overview
    const data = this.props.generatorList.filter((generator: GeneratorEntity) => {
      let didMatch: boolean = false
      if (generator.name === null) {
        generator.name = ""
      }
      if (generator.name.toLowerCase().includes(this.props.filterQuery.toLowerCase())) {
        didMatch = true
      }
      if (generator.categories !== null) {
        generator.categories.forEach((category: string) => {
          if (category.toLowerCase().includes(this.props.filterQuery.toLowerCase())) {
            didMatch = true
          }
        })
      }
      return didMatch
    }).sort((a, b) => a?.name?.toLocaleLowerCase() < b?.name?.toLocaleLowerCase() ? -1 : 1);

    return (
      <>
        <TopNav
          generatorCount={this.props.generatorList.length}
          onViewChange={this.props.switchGenView}
          currentView={this.props.profile.generatorView}
          dispatchFilterEvent={this.props.dispatchFilterEvent}
          searchQuery={this.props.filterQuery}
          title={this.props.title}
          profile={this.props.profile}
          uploadClicked={this.toggleUpload}
        />
        {/* {this.state.showUpload && <Dropzone />} */}
        <GeneratorView
          showDragUi={false}
          generatorList={data}
          view={this.props.profile.generatorView}
          validator={this.props.validator}
          profile={this.props.profile}
          delete={this.confirmDelete}
          run={this.openRunView}
          download={this.handleDownloadClicked}
          openTokenModalForGenerator={this.showTokenModalForGenerator}
        />
        {/* <Droparea refresh={this.props.refreshGens}>
        </Droparea> */}

        {/* Delete COnfirmation dialog. */}
        <div className={"modal " + (this.state.showDeleteDialog ? 'is-active' : '')}>
          <div className="modal-background" onClick={this.closeModal} />
          <div className="modal-card is-danger">
            <header className="modal-card-head">
              <p className="modal-card-title">{this.props.intl.formatMessage(translations.deleting)} {(this.state.generatorToDelete ? '"' + this.state.generatorToDelete.name + '"' : '')}</p>
              <button className="delete" aria-label="close" onClick={this.closeModal} />
            </header>
            <section className="modal-card-body">
              <p style={{ overflow: "hidden" }}>{this.props.intl.formatMessage(translations.deleteQuestion, { generatorName: (this.state.generatorToDelete ? '"' + this.state.generatorToDelete.name + '"' : '') })}</p>

            </section>
            <footer className="modal-card-foot">
              <button className="button is-danger" onClick={this.confirmedDeletion}>{this.props.intl.formatMessage(translations.delete)}</button>
              <button className="button" onClick={this.closeModal} >{this.props.intl.formatMessage(translations.cancel)}</button>
            </footer>
          </div>
        </div>

        {/* Upload Modal */}
        <div className={"modal " + (this.state.showUpload ? 'is-active' : '')}>
          <div className="modal-background" onClick={this.toggleUpload} />
          <div className="modal-card is-danger">
            <header className="modal-card-head">
              <p className="modal-card-title">{this.props.intl.formatMessage(translations.uploadModalTitle)}</p>
              <button className="delete" aria-label="close" onClick={this.toggleUpload} />
            </header>
            <section className="modal-card-body">
              {!this.state.isSaving ?
                (
                  <div><p>{this.props.intl.formatMessage(translations.uploadDropZoneDesc)}</p><Dropzone onDrop={this.dropHandler} /></div>
                )
                :
                (
                  <div>
                    <p>Uploading {this.state.fileCount}</p>
                    {this.state.fileCount > 0 && <progress className="progress is-success" value={this.state.doneSaving} max={this.state.fileCount} />}
                    <p>{this.state.doneSaving} / {this.state.fileCount}</p>
                  </div>
                )
              }
            </section>
            <footer className="modal-card-foot">
              <button className="button" onClick={this.toggleUpload} >{this.props.intl.formatMessage(translations.cancel)}</button>
            </footer>
          </div>
        </div>

        <TokenManager tokenManager={this.state.tokenManager} modalCloseHandler={this.hideTokenModal} />

        {/* Run Quickview Window */}
        <div id="quickviewDefault" className={"quickview " + (this.state.showRunView ? 'is-active' : '')}>
          <header className="quickview-header">
            <span className="icon is-large has-text-danger" >
              <button className={this.props.profile.showTooltips === tooltips.on ? "button is-outlined is-danger " + this.tooltipBottomClass : "button is-outlined is-danger"} data-tooltip={this.props.intl.formatMessage(translations.close)} onClick={this.closeRunView} style={{ width: "50px" }}>
                <span className="icon">
                  <i className="fas fa-angle-double-right" />
                </span>
              </button> {/* tslint:disable-line */}
            </span>
            <span><b>{shortenTo(this.state.generatorToRun.name, 50)}</b></span>
          </header>

          <div className="quickview-body">
            <div className="quickview-block" dangerouslySetInnerHTML={{ __html: this.state.generatorResult }} />
          </div>

          <footer className="quickview-footer">
            <button className="button is-info is-primary" onClick={(e: React.MouseEvent<HTMLButtonElement>) => this.clickRun(e)}>{this.props.intl.formatMessage(translations.runGenerator)}</button> {/* tslint:disable-line */}
            <button className="button is-dark " onClick={this.clearRunResults}> {this.props.intl.formatMessage(translations.clear)}</button>
            <CopyToClipboard text={this.state.clipboardText}>
              <a className={this.props.profile.showTooltips === tooltips.on ? "button is-dark " + this.tooltipLeftClass : "button is-dark "} data-tooltip={this.props.intl.formatMessage(translations.copyToClipboard)} onClick={() => toast({ message: this.props.intl.formatMessage(translations.copiedToClipboard), type: "is-link", dismissible: "true", position: "top-right", opacity: "1", duration: "3500" })}> {/* tslint:disable-line */}
                <span className="icon" >
                  <i className="far fa-copy" />
                </span>
              </a>
            </CopyToClipboard>
          </footer>
        </div>
      </>
    )
  }

  private toggleUpload = () => {
    this.setState({
      ...this.state,
      showUpload: !this.state.showUpload
    })
  }

  private dropHandler = (files: File[]) => {
    // Read the file
    // const files: FileList = e.dataTransfer.files;
    const limit = 25;
    let counter = 0;
    this.setState({
      fileCount: files.length
    })
    for (const key in files) {
      if (key !== 'length' && key !== 'item') {
        if (counter >= limit) {
          toast({ message: "Please keep the uploading Generators to a number less than 25", type: "is-danger", dismissible: "true", position: "top-right", opacity: "1", duration: 5000 })
          return
        } else {
          counter++;
        }

        const fileName = files[key].name;

        const isJson = fileName.endsWith('.json');
        const isCsv = fileName.endsWith('.csv');

        if (isJson || isCsv) {
          const file = files[key];
          const reader = new FileReader()
          reader.onload = (event: any) => {
            try {
              const validateAndSave = (generator: GeneratorEntity) => {
                if (!generator.name) {
                  generator.name = '';
                }
                generator.name = '[IMPORTED] ' + generator.name;

                validateWithoutID(yaml.dump(generator)).then(result => {
                  if (result !== undefined) {
                    if (result.textContent === "[ALL OK]") {
                      this.setState({
                        isSaving: true,
                        startedSaving: this.state.startedSaving + 1
                      })
                      saveNewGenerator(generator).then((saveResult: GeneratorEntity[]) => {
                        if (saveResult !== undefined) {

                          if (this.state.doneSaving + 1 === this.state.startedSaving) {
                            toast({ message: (this.state.doneSaving + 1 + ' generators saved!'), type: "is-success", dismissible: "true", position: "top-right", opacity: "1", duration: 2500 })
                            this.setState({
                              isSaving: false,
                              showUpload: false
                            })
                            this.props.refreshGens();
                          }
                          this.setState({
                            doneSaving: this.state.doneSaving + 1
                          })
                        }
                      })
                    } else {
                      toast({ message: (files[key].name) + " was not valid", type: "is-danger", dismissible: "true", position: "top-right", opacity: "1", duration: 1000000000 })
                    }
                  }
                })
              }

              if (isJson) {
                const generator = JSON.parse(event.target.result)
                validateAndSave(generator);
              }
              else if (isCsv) {
                importCsv(fileName.substr(0, fileName.length - 4), event.target.result, (g, err) => {
                  if (g !== null) {
                    validateAndSave(g);
                  }
                  else {
                    toast({ message: "Invalid CSV file: " + err?.message, type: "is-danger", dismissible: "true", position: "top-right", opacity: "1", duration: 2500 })
                  }
                });
              }
            } catch (e) {
              toast({ message: "Invalid JSON or CSV file.", type: "is-danger", dismissible: "true", position: "top-right", opacity: "1", duration: 2500 })
              return
            }
          }
          // Closure to capture file info
          reader.readAsText(file);
        }
      }
    }
  }


}

export default injectIntl(GeneratorComponent)



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorComponent.tsx